import { render, staticRenderFns } from "./CameraSetup.vue?vue&type=template&id=f79bddb4&scoped=true&"
import script from "./CameraSetup.vue?vue&type=script&lang=js&"
export * from "./CameraSetup.vue?vue&type=script&lang=js&"
import style0 from "./CameraSetup.vue?vue&type=style&index=0&id=f79bddb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79bddb4",
  null
  
)

export default component.exports